import axios from 'axios';
import moment from 'moment';
import Popover from '@/components/popover_component.vue';
export default {
    name: 'bookings_list',
    components: {
        Popover
    },
    data() {
        return{
           bookings:[],
           products:[],
            services_card_index:[],
            deposite_to_be_paid:0,
            temp_balance_due:0,
            service_duration_and_staff:'',
            booked_date:'',
            remove_type:'', //currently no use but once we add products in the list this comes to action
            remove_service_index:'',
            remove_popup:false,
            total_sum : 0,
            paid_amount: 0,
            balance_due : 0,
            total_product_amount:0,
            total_discount_product_amount:0,
            total_service_amount:0,
            current_date : moment().format('YYYY-MM-DD'),
            isReadOnly : true,
            discount_flag:false,
            contenteditable : false
        }
    },
    props:["book_id","multi_book_id"],
    created(){
        this.get_booking_details();
    },
    computed:{
        get_total_service_sum(){      
            if(!this.discount_flag)
            {
                this.total_discount_product_amount=0;
            }
            this.total_service_amount = 0;
            this.bookings.forEach(service => {
                if(service.book_discount_full_amount >= 0 ){
                    if(service.book_discount_full_amount !==""){
                        this.total_service_amount += parseFloat(service.book_discount_full_amount);
                        this.total_discount_product_amount  +=  parseFloat(service.book_fullamount - service.book_discount_full_amount);
                    }
                }
                else{
                    this.total_service_amount += parseFloat(service.book_fullamount);
                    service.book_discount_full_amount = parseFloat(service.book_fullamount);
                }                 
            })

            this.total_discount_product_amount = this.total_discount_product_amount.toFixed(2);
           
            if(!this.discount_flag){    
                this.discount_flag=true;
                this.get_total_product_sum;
                this.discount_flag=false;
            }else{
                this.discount_flag=false;
            }
            this.total_sum  =  (this.total_service_amount +  this.total_product_amount).toFixed(2) ;
            this.balance_due   =  (this.total_sum - this.paid_amount).toFixed(2)
            this.share_updated_amount();

            return this.total_service_amount.toFixed(2);
        },
       
        get_deposit_to_be_paid(){
            this.deposite_to_be_paid = 0;
            this.bookings.forEach(service => {                     
                if(service.book_discount_deposit_amount >= 0){
                    if(service.book_discount_deposit_amount !== ""){
                        this.deposite_to_be_paid += parseFloat(service.book_discount_deposit_amount);
                    }
                }
                else{
                    this.deposite_to_be_paid += parseFloat(service.serv_deposit);
                    service.book_discount_deposit_amount = service.book_deposit;
                }
            })
            if(this.paid_amount > 0){
                this.deposite_to_be_paid = (this.deposite_to_be_paid >0) ? ( parseFloat(this.deposite_to_be_paid-this.paid_amount)) :'' ;
            }
            this.deposite_to_be_paid = this.deposite_to_be_paid > 0 ?  this.deposite_to_be_paid : 0
            this.share_updated_amount();
            return  this.deposite_to_be_paid.toFixed(2) ;
        },
        get_total_product_sum(){
            this.total_product_amount=0;
            if(!this.discount_flag)
            {
                this.total_discount_product_amount= 0;
            }
           
            this.products.forEach(product => {
               
                if(product.product_discount_full_amount >= 0){
                    if(product.product_discount_full_amount !== ""){
                        this.total_product_amount += parseFloat(product.product_discount_full_amount) * product.product_quantity ;
                        this.total_discount_product_amount  =  parseFloat(this.total_discount_product_amount) + ((parseFloat(product.product_full_amount)-parseFloat(product.product_discount_full_amount)) * product.product_quantity);
                        product.temp_full_amount = parseFloat(product.product_discount_full_amount) * product.product_quantity;
                    }
                }
                else{
                    this.total_product_amount += parseFloat(product.product_full_amount * product.product_quantity);
                    product.product_discount_full_amount = parseFloat(product.product_full_amount);
                    product.temp_full_amount = parseFloat(product.product_full_amount * product.product_quantity);
                }
            })

            this.total_discount_product_amount = parseFloat(this.total_discount_product_amount).toFixed(2);
          
            if(!this.discount_flag){    
                this.discount_flag=true;
                this.get_total_service_sum;
                this.discount_flag=false;
            }else{
                this.discount_flag=false;
            }

            this.total_sum  =  (this.total_service_amount +  this.total_product_amount).toFixed(2) ;  
            this.balance_due   =  (this.total_sum - this.paid_amount).toFixed(2)
            this.share_updated_amount();
            return  this.total_product_amount.toFixed(2);
        },


      
    },

    methods:{
        amount_change(type,index){
            if(type == "deposit"){
                this.$refs.deposit_amount[index].className =  " form-control price_border_right amount font-weight-bold " ;
                this.$refs.deposit_label[index].className =  " fa fa-dollar input-icon" ;
                this.$refs.deposit[index].className =  " form-control justify-content-end price_border_left text_decoration ash " ;
                this.$refs.deposit_amount[index].select();
            }
            if(type == "price"){
                this.$refs.price_amount[index].className =  " form-control price_border_right amount font-weight-bold " ;
                this.$refs.price_label[index].className =  " fa fa-dollar input-icon" ;
                this.$refs.price_deposit[index].className =  " form-control justify-content-end price_border_left text_decoration ash " ;
                this.$refs.price_amount[index].select();
            }
           
            
            if(type == "product"){
                this.$refs.product_amount[index].className =  " form-control price_border_right amount font-weight-bold " ;
                this.$refs.product_label[index].className =   " fa fa-dollar input-icon" ;
                this.$refs.product_deposit[index].className =  " form-control justify-content-end price_border_left text_decoration ash " ;
                this.$refs.product_amount[index].select();
            }   
        },

        share_updated_amount() {
            this.$emit('clicked', this.balance_due, this.deposite_to_be_paid);
        },
        remove_card(index,type){  
            this.remove_type = type;
            this.remove_service_index = index;
            this.remove_popup = true;    
        },
        
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) { 
                evt.preventDefault();
            }
			else {
              return true;
            }
        },
       
       async  get_booking_details(){
            this.$emit('show_popover');
            await axios.post(this.$store.state.api +'transactions/get_bookings_payment_amount',{ 
                "book_id": this.book_id,
                "multi_book_id":this.multi_book_id
            }).then(response=>{
                var count=0;
                this.bookings = response.data.result.bookings;
               
                this.temp_balance_due = response.data.result.pay_fullamount;
                this.booked_date = moment(this.bookings[0].book_start_date,'yyyy-MM-DD').format('ddd, MMM D, YYYY');
                this.booked_date_format = moment(this.bookings[0].book_start_date,'yyyy-MM-DD').format('YYYY-MM-DD');
                if(this.booked_date_format  >= this.current_date){
                    this.isReadOnly = false;
                }
                for(var booking_index = 0;booking_index < this.bookings.length;booking_index++){
                    this.bookings[booking_index].book_start_time = moment(this.bookings[booking_index].book_start_time,'HH:mm:ss').format('hh:mm A')
                    this.bookings[booking_index].book_end_time = moment(this.bookings[booking_index].book_end_time,'HH:mm:ss').format('hh:mm A');
                    var difference = ((moment(this.bookings[booking_index].book_end_time,['hh:mm A']) - moment(this.bookings[booking_index].book_start_time,['hh:mm A']))/60)/1000;
                    this.bookings[booking_index].service_duration_and_staff = difference+' min with '+this.bookings[booking_index].staff_first_name+''+this.bookings[booking_index].staff_last_name;
                     
                    this.services_card_index.push({index:count,service_index:'S'+(count+1)})
                    count++;
                }
                this.products = response.data.result.products;
                response.data.result.products.forEach(product => {
                    
                    if(product.product_discount_full_amount >=0){
                        
                        product.temp_full_amount = parseFloat(product.product_discount_full_amount * product.product_quantity) ;

                    }else{
                        product.temp_full_amount = parseFloat(product.product_full_amount * product.product_quantity) ;
                    }

                });
              
                this.update_total();
                this.$emit('close_popover');
                this.$emit('bookingDate',this.bookings[0].book_start_date)
            })
        },
        update_total(){
            this.total_service_amount = 0;
            this.deposite_to_be_paid = 0;
            this.total_discount_product_amount=0;
            for(var booking_index = 0;booking_index < this.bookings.length;booking_index++){
                if(this.bookings[booking_index].book_discount_full_amount >= 0){
                    this.total_service_amount += parseFloat(this.bookings[booking_index].book_discount_full_amount);
                    this.total_discount_product_amount  +=  parseFloat(this.bookings[booking_index].book_fullamount) - parseFloat(this.bookings[booking_index].book_discount_full_amount);
                }
                else{
                    this.total_service_amount += parseFloat(this.bookings[booking_index].book_fullamount);
                    this.bookings[booking_index].book_discount_full_amount =  parseFloat(this.bookings[booking_index].book_fullamount);
                }
               
                if(this.bookings[booking_index].book_discount_deposit_amount >= 0){
                    this.deposite_to_be_paid += parseFloat(this.bookings[booking_index].book_discount_deposit_amount);
                }
                else{
                    this.deposite_to_be_paid += parseFloat(this.bookings[booking_index].book_deposit);
                    this.bookings[booking_index].book_discount_deposit_amount =  parseFloat(this.bookings[booking_index].book_deposit);
                }

               
            }
            
            this.total_product_amount=0;
            for(var j = 0;j < this.products.length;j++){
                if(this.products[j].product_discount_full_amount >= 0){
                    this.total_product_amount += parseFloat(this.products[j].product_discount_full_amount * this.products[j].product_quantity);
                    this.total_discount_product_amount  +=  ((parseFloat(this.products[j].product_full_amount)-parseFloat(this.products[j].product_discount_full_amount)) * this.products[j].product_quantity);
                }
                else{
                    this.total_product_amount += parseFloat(this.products[j].product_full_amount) * this.products[j].product_quantity;
                    this.products[j].product_discount_full_amount = parseFloat(this.products[j].product_full_amount);
                    
                }   

            }

            this.total_discount_product_amount = this.total_discount_product_amount.toFixed(2)
           
            this.total_sum     =      (this.total_service_amount +  this.total_product_amount).toFixed(2) ; 
            this.paid_amount   =      (this.total_sum - this.temp_balance_due).toFixed(2);
            this.balance_due   =      (this.total_sum - this.paid_amount).toFixed(2);
            this.share_updated_amount();
           
        },
        update_price(type,price,book_id,discount_method){
            if (price == '') {
                this.bookings.forEach(service => {
                    if (service.book_discount_full_amount == "") {
                        service.book_discount_full_amount = -1;
                    }
                    if (service.book_discount_full_amount >= 0) {
                        this.total_service_amount += parseFloat(service.book_discount_full_amount);
                        this.total_discount_product_amount += parseFloat(service.book_fullamount - service.book_discount_full_amount);
                    } else {
                        this.total_service_amount += parseFloat(service.book_fullamount);
                        service.book_discount_full_amount = parseFloat(service.book_fullamount);
                    }
                    if (service.book_discount_deposit_amount == "") {
                        service.book_discount_deposit_amount = -1;
                    }
                    if (service.book_discount_deposit_amount >= 0) {
                        this.deposite_to_be_paid += parseFloat(service.book_discount_deposit_amount);
                    } else {
                        this.deposite_to_be_paid += parseFloat(service.book_deposit);
                        service.book_discount_deposit_amount = service.book_deposit;
                    }
                })
                this.products.forEach(product=>{
                    if (product.product_discount_full_amount == "") {
                        product.product_discount_full_amount = -1;
                    }
                    if (product.product_discount_full_amount >= 0) {
                        this.total_product_amount += parseFloat(product.product_discount_full_amount * product.product_quantity ) ;
                        this.total_discount_product_amount  +=  ((product.product_full_amount -product.product_discount_full_amount) * product.product_quantity);

                    } else {
                        this.total_product_amount += parseFloat(product.product_full_amount * product.product_quantity);
                        product.product_discount_full_amount = parseFloat(product.product_full_amount);
                    }
                })

                 
            }
            axios.post(this.$store.state.api +'v2/booking/update_prices_v2',{ 
                "type": type,
                "price":(price !='' ) ? parseFloat(price) : -1,
                "id": parseInt(book_id),
                "discount_method":parseInt(discount_method)
            }).then(response=>{
                return response;
            })
            
        },
       
        remove_service_card(){
            this.$store.commit('service_status_update',[this.bookings[this.remove_service_index].book_id,0,this.Constants.STATUS_EARLY_CANCELLED,this.$store.state.user_id,this.Constants.BOOKED_THROUGH_ADMIN,this.Constants.EDIT_FLAG]);
            this.services_card_index.splice(this.services_card_index.length-1,1);
            this.bookings.splice(this.remove_service_index,1);
            this.update_total(); 
            if(!this.bookings.length) this.$router.push('/calendar')
            this.remove_popup = false;
        },
        remove_popup_card(){
            this.remove_popup = false;
        },
        route_to_editbooking(){
            this.$session.set('book_id',this.book_id);
            this.$session.set('multi_book_id',this.multi_book_id);
            this.$session.set('booking_type',this.Constants.BOOKING_TYPE_EDIT_BOOKING)
            this.$session.set('editbooking',true);
            this.$router.push('/newbooking');
        }
    }
   
}